import { render, staticRenderFns } from "./LicensePlateForm.vue?vue&type=template&id=ddd26b2e&"
import script from "./LicensePlateForm.vue?vue&type=script&lang=js&"
export * from "./LicensePlateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports